export const Role = {
  Viewer: 'viewer',
  Consultant: 'consultant',
  Techniker: 'techniker',
  Lead: 'lead',
  Admin: 'admin',
} as const

export type Role = (typeof Role)[keyof typeof Role]

const ORDER: Role[] = [Role.Viewer, Role.Consultant, Role.Techniker, Role.Lead, Role.Admin]

export function rank(r: Role): number { return ORDER.indexOf(r) }
export function atLeast(actual: Role, required: Role): boolean { return rank(actual) >= rank(required) }
export function parseRole(s: string | null | undefined): Role | null {
  const v = (s ?? '').toLowerCase()
  return (ORDER as string[]).includes(v) ? (v as Role) : null
}

export type Capability =
  | 'viewDashboard'      // Viewer+
  | 'openAgentDetail'    // Consultant+
  | 'viewAgentList'      // Consultant+
  | 'editAgent'          // Techniker+
  | 'createAgent'        // Lead+
  | 'manageEntities'     // Lead+ (contacts, functions, tags, customers, providers, unknown agents)
  | 'manageUsers'        // Admin
  | 'manageSettings'     // Admin
  | 'viewCases'          // Consultant+
  | 'editCases'          // Techniker+
  | 'bulkCloseCases'     // Techniker+
  | 'submitRequest'      // Viewer+ (Server zur Überwachung anmelden)
  | 'manageRequests'     // Lead+ (Anforderungen verwalten/genehmigen/ablehnen)
  | 'manageVmPermissions'   // Lead+ (per-VM permission matrix)
  | 'manageAgentEnrollment'  // Lead+ (download enrollment config + reset enrollment / OTP)
  | 'manageCloudWorkers'     // Lead+ (Prüfstandorte: anlegen, Enrollment-OTP, entfernen)

const MIN: Record<Capability, Role> = {
  viewDashboard: Role.Viewer,
  openAgentDetail: Role.Consultant,
  viewAgentList: Role.Consultant,
  editAgent: Role.Techniker,
  createAgent: Role.Lead,
  manageEntities: Role.Lead,
  manageUsers: Role.Admin,
  manageSettings: Role.Admin,
  viewCases: Role.Consultant,
  editCases: Role.Techniker,
  bulkCloseCases: Role.Techniker,
  submitRequest: Role.Viewer,
  manageRequests: Role.Lead,
  manageVmPermissions: Role.Lead,
  manageAgentEnrollment: Role.Lead,
  manageCloudWorkers: Role.Lead,
}

export function can(role: Role, cap: Capability): boolean { return atLeast(role, MIN[cap]) }
